import { startCase } from 'lodash';

// The service `type` vocabulary. NOT free text: the GE pricing algo dispatches on it with a
// `switch (svc.type)` over these exact lowercase strings and does not normalize, so a miscased
// or invented value falls through to `default` and prices the line at $0 (UNPRICEABLE).
//
// Source of truth: onward-functions src/pricing/algos/generalElectric.js (the switch cases) and
// SERVICE_TYPE_RULES in src/lib/integrations/clients/general_electric/utils.js (which derives
// them on import). Add a value here only when a case exists there.
//
// 'unknown' is deliberately omitted: it's the parser's "couldn't classify" sentinel, not
// something to assign by hand, and the ingestion stamp treats it as an unset value anyway.
export const SERVICE_TYPES = [
    'delivery_bucket',
    'home_delivery',
    'install',
    'm_code',
    'minimum',
    'non_billable',
    'restocking',
    'trip',
    'uncrate',
];

// Display form of a stored service type ('non_billable' -> 'Non Billable'). Values are always
// stored raw; this is presentation only.
export const serviceTypeLabel = (type) => (type ? startCase(type) : '');
